import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, firstValueFrom, lastValueFrom, Subject } from 'rxjs';
import { MatchData, ScheduledEntry } from 'src/app/_interfaces';

@Injectable({
    providedIn: 'root'
})
export class ScheduledEntryStateService {

    entry: BehaviorSubject<ScheduledEntry> = new BehaviorSubject<ScheduledEntry>({} as ScheduledEntry)
    matches: BehaviorSubject<MatchData[]> = new BehaviorSubject<MatchData[]>([])

    get__MatchesPromise(): Promise<MatchData[]> {
        return firstValueFrom(this.matches.pipe(
            filter(value => value !== null)
        ))
    }

    get__EntryPromise(): Promise<ScheduledEntry> {
        return firstValueFrom(this.entry.pipe(
            filter(value => value !== null && Object.keys(value).length > 0)
        ))
    }
}
